export { lockBodyScroll, unlockBodyScroll } from './body-scroll';
